import type React from 'react';
import {
    faBatteryEmpty,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from '../../../../../utils/tooltip';
import type { ProjectMeasuringPointRowViewData } from '../../utils/projectMeasuringPointRowViewData';
import classNames from '../../../../../utils/classNames';
import { MEASURING_POINT_CELL_CLASSES, TOOLTIP_TRIGGER_CLASSES } from './cellClasses';

export function ProjectMeasuringPointDeviceCell({
    viewData,
}: {
    viewData: ProjectMeasuringPointRowViewData;
}): React.ReactElement {
    const {
        batteryCharge,
        batteryIconLevel,
        batteryTooltip,
        deviceLabel,
        showSubscriptionWarning,
    } = viewData;
    const batteryIcons = [
        faBatteryEmpty,
        faBatteryQuarter,
        faBatteryHalf,
        faBatteryThreeQuarters,
        faBatteryFull,
    ] as const;
    const batteryIcon = batteryIconLevel !== null ? batteryIcons[batteryIconLevel] : null;

    return (
        <td className={MEASURING_POINT_CELL_CLASSES}>
            <Tooltip
                rounded
                content={batteryTooltip}
                disabled={!batteryTooltip}
                placement="bottom-start"
            >
                <div
                    className={classNames(
                        'flex w-max flex-col items-start gap-1',
                        batteryTooltip && TOOLTIP_TRIGGER_CLASSES
                    )}
                    {...(batteryTooltip ? { tabIndex: 0 } : {})}
                >
                    <span className="truncate" title={deviceLabel}>
                        {deviceLabel}
                    </span>
                    {batteryCharge !== null && batteryCharge !== undefined && (
                        <span
                            className="inline-flex items-center gap-1 whitespace-nowrap"
                            aria-label={interpolate(
                                gettext('BATTERY_PERCENT'),
                                { percent: batteryCharge },
                                true
                            )}
                        >
                            {batteryCharge}%
                            {batteryIcon && (
                                <FontAwesomeIcon
                                    icon={batteryIcon}
                                    className="h-3.5 w-3.5"
                                    aria-hidden
                                />
                            )}
                        </span>
                    )}
                </div>
            </Tooltip>
            {showSubscriptionWarning && (
                <span className="text-error mt-1 inline-flex items-center gap-1">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="h-3.5 w-3.5"
                        aria-hidden
                    />
                    <span>{gettext('NO_SUBSCRIPTION')}</span>
                </span>
            )}
        </td>
    );
}
